import { render, staticRenderFns } from "./test1.vue?vue&type=template&id=9c475e14&scoped=true"
import script from "./test1.vue?vue&type=script&lang=js"
export * from "./test1.vue?vue&type=script&lang=js"
import style0 from "./test1.vue?vue&type=style&index=0&id=9c475e14&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c475e14",
  null
  
)

export default component.exports